module.exports = __webpack_public_path__ + "static/media/replicating-bacterial-vector.635a1e9e.jpg";